import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import PopupWrapper from "../PopupWrapper";

const UseSignature = ({ title, field, register, setValue, watch, error }) => {
  const signatureRef = useRef(null);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [signature, setSignature] = useState(null);

  useEffect(() => {
    register(field);
  }, [field, register]);

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };

  const saveSignature = async (e) => {
    e.preventDefault();
    if (signatureRef.current) {
      const response = await fetch(
        signatureRef.current.getTrimmedCanvas().toDataURL("image/png")
      );
      const blob = await response.blob();
      const base64Signature = await convertBlobToBase64(blob);

      setValue(field, base64Signature);
      setSignature(base64Signature);
      setShowSignaturePad(false);
    }
  };

  const clearSignature = (e) => {
    e.preventDefault();
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  return (
    <div>
      {signature ? (
        <div
          onClick={() => setShowSignaturePad(true)}
          style={{
            border: "1px solid #ced4da",
            height: "60px",
            borderRadius: "0.25rem",
            cursor: "pointer",
            paddingLeft: "2rem",
          }}
        >
          <img
            src={signature}
            alt="Signature"
            style={{ width: "100px", height: "50px" }}
            onClick={() => setShowSignaturePad(true)}
          />
        </div>
      ) : (
        <div
          onClick={() => setShowSignaturePad(true)}
          style={{
            border: "1px solid #ced4da",
            padding: "16px",
            borderRadius: "0.25rem",
            cursor: "pointer",
          }}
        >
          <span className="cursor-pointer" style={{ opacity: "0.5" }}>
            {title}
          </span>
        </div>
      )}

      {showSignaturePad && (
        <PopupWrapper
          title={"Sign Here"}
          Component={
            <div
              style={{
                backgroundColor: "white",
                // padding: "20px",
                // position: "relative",
              }}
            >
              <div className="border border-1">
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="black"
                  canvasProps={{
                    width: "700px",
                    height: "100px",
                    className: "sigCanvas",
                  }}
                />
              </div>
              <div className="d-flex justify-content-end gap-5 mt-5 mb-3">
                <button className="btn btn-secondary" onClick={clearSignature}>
                  Clear
                </button>
                <button className="btn btn-primary" onClick={saveSignature}>
                  Save
                </button>
              </div>
            </div>
          }
          toShow={showSignaturePad}
          extraClass={"min-width-50vw"}
          closeEventHandler={() => {
            setShowSignaturePad(false);
          }}
          titleClassName={"w-100"}
          bodyStyle={
            {
              // maxHeight: "50vh",
            }
          }
        />
      )}
    </div>
  );
};

export default UseSignature;
